import React from 'react';
import { B } from '../constants';

export default function TermsScreen({ goScreen }) {
  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: '40px 20px', fontFamily: "'Montserrat',sans-serif", lineHeight: 1.7 }}>
      <button onClick={() => goScreen(-1)} style={{ background: 'none', border: 'none', fontSize: 24, cursor: 'pointer', marginBottom: 20 }}>← Back</button>
      
      <h1 style={{ fontFamily: "'Playfair Display',serif", fontSize: 32, color: B.night, marginBottom: 24 }}>Terms of Service</h1>
      
      <p style={{ color: B.muted, marginBottom: 32 }}>Last updated: April 2026</p>

      <div style={{ fontSize: 14, color: '#444' }}>
        <h2 style={{ fontSize: 18, marginTop: 32, marginBottom: 12, color: B.night }}>1. Acceptance of Terms</h2>
        <p>By accessing and using GreatBreak, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our service.</p>

        <h2 style={{ fontSize: 18, marginTop: 32, marginBottom: 12, color: B.night }}>2. Use of Service</h2>
        <p>GreatBreak provides AI-powered trip planning, itinerary management, and travel content generation. You agree to:</p>
        <ul style={{ marginLeft: 20, marginTop: 8 }}>
          <li>Provide accurate information</li>
          <li>Use the service for lawful purposes only</li>
          <li>Not attempt to harm or disrupt the service</li>
        </ul>

        <h2 style={{ fontSize: 18, marginTop: 32, marginBottom: 12, color: B.night }}>3. AI Content Disclaimer</h2>
        <p style={{ background: '#fff3cd', padding: 16, borderRadius: 8, border: '1px solid #ffeeba' }}>
          ⚠️ <strong>Important:</strong> Our AI generates itineraries and content based on AI models. We strive for accuracy but cannot guarantee that all information, including pricing, availability, visa requirements, health advisories, or local regulations is 100% accurate. Always verify critical information (visas, flights, health requirements) with official sources before making travel decisions.
        </p>

        <h2 style={{ fontSize: 18, marginTop: 32, marginBottom: 12, color: B.night }}>4. User Content</h2>
        <p>You retain ownership of content you create (trip logs, experiences, photos) but grant GreatBreak a license to store and display your content as part of your account and any public sharing features you enable.</p>

        <h2 style={{ fontSize: 18, marginTop: 32, marginBottom: 12, color: B.night }}>5. Accounts & Security</h2>
        <p>You are responsible for maintaining the confidentiality of your account credentials. Report any unauthorized access immediately.</p>

        <h2 style={{ fontSize: 18, marginTop: 32, marginBottom: 12, color: B.night }}>6. Prohibited Uses</h2>
        <p>You may not use GreatBreak to:</p>
        <ul style={{ marginLeft: 20, marginTop: 8 }}>
          <li>Generate harmful or illegal content</li>
          <li>Share content that violates third-party rights</li>
          <li>Attempt to reverse-engineer our AI systems</li>
          <li>Use automated tools to extract data without permission</li>
        </ul>

        <h2 style={{ fontSize: 18, marginTop: 32, marginBottom: 12, color: B.night }}>7. Limitation of Liability</h2>
        <p>GreatBreak is provided "as is" without warranties. We are not liable for any damages arising from your use of the service, including but not limited to inaccurate AI-generated content or travel disruptions.</p>

        <h2 style={{ fontSize: 18, marginTop: 32, marginBottom: 12, color: B.night }}>8. Changes to Terms</h2>
        <p>We may update these terms at any time. Continued use after changes constitutes acceptance of new terms.</p>

        <h2 style={{ fontSize: 18, marginTop: 32, marginBottom: 12, color: B.night }}>9. Contact</h2>
        <p>Questions? Contact us at support@greatbreak.com</p>
      </div>
    </div>
  );
}